import { buildOrganization } from "../siteIdentity"

const Publisher = () => {
  return buildOrganization()
}

export default Publisher
